import { formatApiDateToUkDisplay } from '@/_helpers';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'apiDateUk'
})
export class ApiDateUkPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatApiDateToUkDisplay(value);
  }
}
